/**
 * Custom image renderer for gallery view
 *
 * Props received from GDImageViewer:
 * - item:        { id, name, modifiedTime }
 * - openSrc:     (id, large?) => string URL
 * - onClick:     () => void
 * - classes:     slot-based className map
 * - styles:      slot-based inline-style map
 * - hover:       boolean
 * - attachClass: { [filename]: string }
 * - attachId:    { [filename]: string }
 */
export default function SingleGalleryImage({
  item,
  openSrc,
  onClick,
  classes,
  styles,
  hover,
  attachClass = {},
  attachId = {},
}) {
  const { id, name } = item;

  return (
    <div className={classes.thumbWrapper} style={styles.thumbWrapper}>
      <img
        src={openSrc(id)}
        alt={name}
        className={[
          classes.image,
          hover && "gd-hover",
          attachClass[name],
        ]
          .filter(Boolean)
          .join(" ")}
        style={styles.image}
        id={attachId[name]}
        onClick={onClick}
      />
    </div>
  );
}
